// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7565997a","455":"c0101de8"}[chunkId] + ".chunk.js";
};